import type { HTMLAttributes } from "react";
import { cn } from "../lib/utils";
import { Icon } from "./icon";

const sizeMap = {
  small: 24,
  medium: 30,
  large: 36,
} as const;

export interface InlineSpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: keyof typeof sizeMap;
  iconClassName?: string;
}

export const InlineSpinner = ({
  size = "large",
  iconClassName = "text-primary",
  className,
  ...props
}: InlineSpinnerProps) => {
  const iconSize = sizeMap[size];

  return (
    <div {...props} className={cn("inline-flex items-center", className)}>
      <Icon
        icon="loader-circle"
        size={iconSize}
        className={cn("animate-spin", iconClassName)}
        strokeWidth={3}
      />
    </div>
  );
};

InlineSpinner.displayName = "InlineSpinner";
